module.exports = "/static/hooks/build/assets/open-iconic-93cc7aa654ae36b0828716f5ec3159cd.ttf";